import Done from '@mui/icons-material/Done';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function DoneIcon(props: FixMe) {
  return <Done {...props} />;
}

export default DoneIcon;
